<template>
  <button @click.stop="$emit('click')" :style="{backgroundColor: bg}"
 ><div v-if="icon" :style="[{maskImage: `url(./svg/btn/${icon}.svg)`}, iconSize?{width: `${iconSize}px`, height: `${iconSize}px`}:{}]"></div>{{text}}</button>
</template>

<script>
export default {
  props: ['icon', 'text', 'bg', 'iconSize']

}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
button {
  padding: 0 20px;
  height: 40px;
  color: #FFFFFF;
  border-radius: 3px;
  letter-spacing: 0.1em;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  &>div{
    width: 15px;
    height: 15px;
    background-color: #FFFFFF;
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
  }
}
}
</style>

<style lang="scss" scoped>
@media screen and (orientation: portrait) {
button {
  color: #FFFFFF;
  padding: 10px 20px;
  border-radius: 3px;
}
}
</style>
